import React from 'react';
import { IoLogoFacebook, IoLogoInstagram, IoLogoTwitter } from 'react-icons/io';
import DraugiemIcon from '../../../img/draugiem-icon.inline.svg';
// TODO: Source links from Wordpress?
export var SocialLinks = function SocialLinks() {
  return /*#__PURE__*/React.createElement("div", {
    className: "columns social-links is-mobile is-centered"
  }, /*#__PURE__*/React.createElement(SocialLink, {
    title: "Facebook",
    url: "/"
  }, /*#__PURE__*/React.createElement(IoLogoFacebook, {
    size: "2em"
  })), /*#__PURE__*/React.createElement(SocialLink, {
    title: "Instagram",
    url: "/"
  }, /*#__PURE__*/React.createElement(IoLogoInstagram, {
    size: "2em"
  })), /*#__PURE__*/React.createElement(SocialLink, {
    title: "Twitter",
    url: "/"
  }, /*#__PURE__*/React.createElement(IoLogoTwitter, {
    size: "2em"
  })), /*#__PURE__*/React.createElement(SocialLink, {
    title: "Draugiem",
    url: "/"
  }, /*#__PURE__*/React.createElement(DraugiemIcon, null)));
};

var SocialLink = function SocialLink(_ref) {
  var title = _ref.title,
      url = _ref.url,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "column is-narrow has-text-centered"
  }, /*#__PURE__*/React.createElement("a", {
    className: "social-icon",
    href: url,
    rel: "noopener noreferrer",
    target: "_blank",
    title: title
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, children)));
};

export default SocialLinks;